





















































































































































































































































































































































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import Map from '@/components/master-data/address/Map.vue'
import {
  CREATE_ADDRESS,
  CREATE_ADDRESS_EMPLOYEE, FETCH_ADDRESS_COLOR_LIST, FETCH_ADDRESS_CONTACT_LIST,
  FETCH_ADDRESS_DETAIL, FETCH_ADDRESS_POST_CODE_DATA, FETCH_COMMISSION_GROUP,
  FETCH_FUNCTION_LIST,
  FETCH_LAND_LIST,
  FETCH_SALUTATION, FETCH_SEARCH_COMMISSION_LIST,
  FETCH_TITLE_LIST, SET_DISPOSITION_ADDRESS
} from '@/store/action-types'
import { Title } from '@/model/addresses/Title'
import { GridOptions, UiLanguageList } from '@/types'
import { Land } from '@/model/addresses/Land'
import ColorPicker from '@/components/ColorPicker.vue'
import { AddressDetail } from '@/model/addresses/AddressDetail'
import { AddressEmployee } from '@/model/addresses/AddressEmployee'
import { Salutation } from '@/model/addresses/Salutation'
import { ActionsEnum, KeyActionEnum, SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import AddressEmployeeDialog from '@/components/master-data/address/AddressEmployeeDialog.vue'
import {
  AddressDataPayload,
  AddressEmployeeDataPayload,
  KommissionSearchRequest,
  PostCodeDataPayload
} from '@/types/payload'
import moment from 'moment'
import { EmployeeFunction } from '@/model/addresses/EmployeeFunction'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { TranslateResult } from 'vue-i18n'
import { AddressColor } from '@/model/addresses/AddressColor'
import AddressReports from '@/components/master-data/address/AddressReports.vue'
import AdditionalFields from '@/components/additional-fields/AdditionalFields.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import AddressResponsibleEmployees from '@/components/master-data/address/AddressResponsibleEmployees.vue'
import AddressRequirements from '@/components/master-data/address/AddressRequirements.vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import Notes from '@/components/master-data/address/Notes.vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import AddressProjectAddress from '@/components/master-data/address/AddressProjectAddress.vue'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import {
  ContactListItem,
  GetContactListResponse,
  GetOrtPlzResponse,
  KommissionSearchResponse
} from '@/types/service-response'
import PostCodeDialog from '@/components/master-data/address/PostCodeDialog.vue'
import { PostCodeData } from '@/model/addresses/PostCodeData'
import * as securityService from '@/services/security-service'
import WebReportReinigung from '@/components/master-data/address/WebReportReinigung.vue'
import WebReportProjektManagement from '@/components/master-data/address/WebReportProjektManagement.vue'
import WebReportPFA from '@/components/master-data/address/WebReportPFA.vue'
import Documents from '@/components/Documents.vue'
import { SearchCommission } from '@/model/commissions/SearchCommission'
import { CommissionGroup } from '@/model/commissions/CommissionGroup'
import CommissionWindow from '@/components/master-data/commissions/CommissionWindow.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Search extends KeyAction {}

interface ComponentData {
  activeTab: number
  activeTab2: number
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  salutationList: Salutation[]
  titleList: Title[]
  landList: Land[]
  colorList: AddressColor[]
  functionList: EmployeeFunction[]
  //defaultColor: string

  selectedAddressGroupId: number | undefined
  selectedLanguage: number | undefined
  addressNumber: string
  sorting: string
  name: string
  land: number | undefined
  selectedSalutation: number | undefined
  selectedTitle: number | undefined
  firstName: string
  addition: string
  street: string
  pobox: string
  houseNumber: string
  postcode: string
  city: string
  region: string
  businessPhone: string
  privatePhone: string
  businessMobile: string
  businessMail: string
  privateMail: string
  webPage: string
  privateMobile: string
  description: string
  active: boolean
  color: string
  isPrivateAddress: boolean
  geoLat: string | undefined,
  geoLon: string | undefined,

  addressEmployee: Array<AddressEmployee>
  gridData: Array<AddressEmployee>
  gridOptions: GridOptions
  overlayNoRowsTemplate: string
  showAll: boolean
  currentSelectedRowId: string
  showAddressEmployeeDialog: boolean
  isEmployeeDialogIsEdit: boolean
  addressEmployeeTitle: string
  addressAction: ActionsEnum
  action: ActionsEnum | undefined
  currentSelectedRowData: AddressEmployee | undefined
  showDeleteDialog: boolean
  showPostCodeDialog: boolean
  postCodeData: PostCodeData[]
  isAddressDeleteAction: boolean
  houseNumberRule: any
  loading: boolean
  saveLoading: boolean
  employeeDialogLoading: boolean
  validationRules: Array<Function>

  selectedAddressId: number | undefined
  addressIdIndex: number
  isEdit: boolean
  showWebReport: boolean
  refreshAdditionalFields: boolean
  geoRules: Array<Function>
  contactList: ContactListItem[]

  commissionArtList: CommissionGroup[]
  commissionIdList: number[]
  commissionList: SearchCommission[]

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'AddressWindow',

  components: {
    AddressReports,
    AdditionalFields,
    Notes,
    AddressRequirements,
    ColorPicker,
    AgGridVue,
    AddressEmployeeDialog,
    DeleteDialog,
    AddressResponsibleEmployees,
    ProgressCircular,
    Map,
    AddressProjectAddress,
    WebReportProjektManagement,
    WebReportPFA,
    WebReportReinigung,
    PostCodeDialog,
    Documents,
    CommissionWindow
  },

  props: {
    showDialog: Boolean,
    addressGroupId: Number,
    addressIdList: Array as () => number[],
    addressGroupList: Array as () => AddressGroup[]
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()
    const geoRule = (value: string) => {
      const pattern = /^(\d+(?:[\.\,]\d{1,20})?)$/
      return value && value.length >= 1 ? pattern.test(value) || '' : true
    }

    return {
      activeTab: 0,
      activeTab2: 0,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      salutationList: [],
      titleList: [],
      landList: [],
      colorList: [],
      functionList: [],
      //defaultColor: '#000',

      selectedAddressGroupId: undefined,
      selectedLanguage: undefined,
      addressNumber: '',
      sorting: '',
      name: '',
      land: undefined,
      selectedSalutation: undefined,
      selectedTitle: undefined,
      firstName: '',
      addition: '',
      street: '',
      pobox: '',
      houseNumber: '',
      postcode: '',
      city: '',
      region: '',
      businessPhone: '',
      privatePhone: '',
      businessMobile: '',
      businessMail: '',
      privateMail: '',
      webPage: '',
      privateMobile: '',
      description: '',
      active: true,
      color: '',
      isPrivateAddress: true,
      geoLat: undefined,
      geoLon: undefined,

      addressEmployee: [],
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.addresses.firstName'), field: 'firstName' },
          { headerName: this.$t('masterData.addresses.name'), field: 'name' },
          { headerName: this.$t('masterData.addresses.salutation'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const foundSalutation: Salutation = this.salutationList.find((item: Salutation) => item.id === params.data.salutation)
              return foundSalutation ? foundSalutation.name : ''
            }
          },
          { headerName: this.$t('masterData.addresses.title'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const foundTitle: Title = this.titleList.find((item: Title) => item.id === params.data.title)
              return foundTitle ? foundTitle.name : ''
            }
          },
          { headerName: this.$t('masterData.addresses.telNumber'), field: 'businessPhone' },
          { headerName: this.$t('masterData.addresses.email'), field: 'businessMail' },
          { headerName: this.$t('masterData.addresses.mobile'), field: 'businessMobile' },
          {
            headerName: this.$t('masterData.addresses.function'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const foundPosition: EmployeeFunction = this.functionList.find((item: EmployeeFunction) => item.id === params.data.position)
              return foundPosition ? foundPosition.name : ''
            },
          },
          { headerName: this.$t('masterData.addresses.department'), field: 'department' },
          { headerName: this.$t('masterData.addresses.supervisor'), field: 'supervisor' },
          { headerName: this.$t('masterData.addresses.birthday'), field: 'dateOfBirth' }
        ]
      },
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      showAll: false,
      currentSelectedRowId: '',
      showAddressEmployeeDialog: false,
      isEmployeeDialogIsEdit: false,
      addressEmployeeTitle: '',
      addressAction: ActionsEnum.CREATE,
      action: undefined,
      currentSelectedRowData: undefined,
      showDeleteDialog: false,
      showPostCodeDialog: false,
      postCodeData: [],
      isAddressDeleteAction: true,
      houseNumberRule: [(v: string) => v.length <= 16 || 'Max 16 characters'],
      loading: false,
      saveLoading: false,
      employeeDialogLoading: false,
      validationRules: [required],

      selectedAddressId: undefined,
      addressIdIndex: 0,
      isEdit: false,
      showWebReport: false,
      refreshAdditionalFields: false,
      geoRules: [geoRule],
      contactList: [],

      commissionArtList: [],
      commissionIdList: [],
      commissionList: [],

      keyActions: []
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    isAddButtonEnabled (): boolean {
      return true
    },

    isEnableButtons (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    isShowButtonEnabled (): boolean {
      return true
    },

    webReportName (): string {
      return this.$store.state.currentUser.defWebreportTemplate
    },

    setShowButtonIcon (): string {
      if(this.showAll) {
        return 'visibility'
      } else {
        return 'visibility_off'
      }
    },

    showMap (): boolean {
      if(this.geoLat && this.geoLon) {
        return true
      } else {
        return false
      }
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    getAddressTitle (): string {
      if(this.addressNumber || this.name) {
        return `${this.addressNumber ? this.addressNumber : ''} ${this.name ? this.name : ''}`
      } else {
        return ''
      }
    },

    isAddressBeforeDisabled (): boolean {
      return this.addressIdIndex === 0
    },

    isAddressAfterDisabled (): boolean {
      return this.addressIdIndex === this.addressIdList.length -1
    },

    showAllocationButton (): boolean {
      return securityService.isVisible(SecurityArea.PersonalDisposition, SecurityComponent.Allocation)
    },

    isDisabledAllocationButton (): boolean {
      return securityService.isDisabled(SecurityArea.PersonalDisposition, SecurityComponent.Allocation)
    },

    showInsertButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconInsert)
    },

    isDisabledInsertButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconInsert)
    },

    showUpdateButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconUpdate)
    },

    isDisabledUpdateButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconUpdate)
    },

    showDeleteButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconDelete)
    },

    isDisabledDeleteButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconDelete)
    }
  },

  watch: {
    selectedAddressId (newVal: number): void {
      const form: any = this.$refs['form']
      form.resetValidation()
      if(newVal !== 0) {
        this.geoLon = undefined
        this.geoLon = undefined
        this.addressAction = ActionsEnum.EDIT
        this.isEdit = false
        this.fetchAddressDetailData()
      } else {
        this.activeTab = 0
        this.addressAction = ActionsEnum.CREATE
        const emptyData = AddressDetail.createEmpty()
        this.setData(emptyData)
        this.setDefaultValues()
      }
    },

    activeTab (newVal: number): void {
      if(newVal && newVal === 6) {
        this.searchCommission()
        this.fetchCommissionArtList()
      }
      let data: any = this.getRouteData()
      data.addressTab = newVal
      this.$router.push({ name: 'AddressSearch', query: { data: JSON.stringify(data) } })
    },

    activeTab2 (newVal: number): void {
      let data: any = this.getRouteData()
      data.addressTab2 = newVal
      this.$router.push({ name: 'AddressSearch', query: { data: JSON.stringify(data) } })
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Search | null): boolean {
      if(action instanceof Create) {
        return this.isAddButtonEnabled && this.activeTab === 0
      } else if(action instanceof Edit) {
        return this.isEnableButtons && this.activeTab === 0
      } else if(action instanceof Delete) {
        return this.isEnableButtons
      } else if(action instanceof Search) {
        return true
      } else {
        return false
      }
    },

    /*getContactIcon (item: string | null): string {
      if(item) {
        switch (item) {
          case '001':
            return 'phone'
          case '002':
            return 'fax'
          case '003':
            return 'smartphone'
          case '004':
            return 'email'
          case '005':
            return 'mdi-web'
          case '006':
            return 'phone'
          case '007':
            return 'smartphone'
          case '008':
            return 'email'
          default:
              return ''
        }
      } else {
        return ''
      }
    },*/

    onPostCodeChange (code: string): void {
      this.fetchPostCodeData(code)
    },

    onPostCodeDialogClose (): void {
      this.showPostCodeDialog = false
    },

    onPostCodeDialogSave (data: PostCodeData): void {
      this.city = data.ort
      this.region = data.region
      this.showPostCodeDialog = false
    },

    onAddAddressClick (): void {
      this.isEdit = true
      this.addressIdIndex = 0
      this.selectedAddressId = 0
      this.$emit('startCreate')

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onEditAddressClick (): void {
      this.isEdit = true

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
          focusedField.$el.querySelector('input').select()
        }
      }, 0)
    },

    onDeleteAddressClick (): void {
      this.isAddressDeleteAction = true
      this.showDeleteDialog = true
    },

    onAddressBeforeClick (): void {
      this.addressIdIndex -= 1
      this.selectedAddressId = this.addressIdList[this.addressIdIndex]
      let data: any = this.getRouteData()
      data.addressIdIndex = this.addressIdIndex
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(data) }})
    },

    onAddressAfterClick (): void {
      this.addressIdIndex += 1
      this.selectedAddressId = this.addressIdList[this.addressIdIndex]
      let data: any = this.getRouteData()
      data.addressIdIndex = this.addressIdIndex
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(data) }})
    },

    onSearchClick (): void {
      this.$emit('close')
    },

    searchClick (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      this.$emit('close')
    },

    onWebReportClick (): void {
      this.showWebReport = true
    },

    onWebReportDialogSaved (): void {
      this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
      this.snackbarState = SnackbarStateEnum.Success
      this.showSnackbar = true
    },

    onWebReportDialogClose (): void {
      this.showWebReport = false
      if(this.activeTab === 2) {
        this.refreshAdditionalFields = true
      }
    },

    onCloseDialog (): void {
      this.$emit('close')
    },
    /*onColorChange (color: Color): void {
      this.color = color.hex
    },*/

    onDispositionClick (): void {
      this.$store.dispatch(SET_DISPOSITION_ADDRESS, this.selectedAddressId)
      this.$router.push('/disposition/allocation')
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: AddressEmployee) => item.id === parseInt(this.currentSelectedRowId))
    },

    onRowDblClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: AddressEmployee) => item.id === parseInt(this.currentSelectedRowId))
      this.addressEmployeeTitle = this.currentSelectedRowData ? `${this.currentSelectedRowData.firstName} ${this.currentSelectedRowData.name}` : ''
      this.showAddressEmployeeDialog = true
      this.isEmployeeDialogIsEdit = false
    },

    onAddEmployeeClick (): void {
      this.currentSelectedRowData = AddressEmployee.createEmpty(this.selectedAddressId!)
      this.addressEmployeeTitle = this.$t('masterData.addresses.addDialogTitle').toString()
      this.action = ActionsEnum.CREATE
      this.showAddressEmployeeDialog = true
      this.isEmployeeDialogIsEdit = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddEmployeeClick()
    },

    onEditEmployeeButtonClick (): void {
      this.addressEmployeeTitle = this.$t('masterData.addresses.editDialogTitle').toString()
      this.action = ActionsEnum.EDIT
      this.showAddressEmployeeDialog = true
      this.isEmployeeDialogIsEdit = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditEmployeeButtonClick()
    },

    onDeleteEmployeeButtonClick (): void {
      this.isAddressDeleteAction = false
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteEmployeeButtonClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.showDeleteDialog = false
      if(this.isAddressDeleteAction) {
        this.addressAction = ActionsEnum.DELETE
        this.onSaveButtonClick()
      } else {
        this.deleteEmployee()
      }
    },

    deleteEmployee (): void {
      this.action = ActionsEnum.DELETE
      if(this.currentSelectedRowData) {
        const payload: AddressEmployeeDataPayload = {
          id: this.currentSelectedRowData ? this.currentSelectedRowData.id : undefined,
          address: this.currentSelectedRowData.address,
          privatAddress: this.currentSelectedRowData.privatAddress,
          name: this.currentSelectedRowData.name,
          firstName: this.currentSelectedRowData.firstName,
          language: this.currentSelectedRowData.language? this.currentSelectedRowData.language : this.selectedLanguageId,
          title: this.currentSelectedRowData.title ? this.currentSelectedRowData.title : null,
          salutation: this.currentSelectedRowData.salutation ? this.currentSelectedRowData.salutation : null,
          genAddress: this.currentSelectedRowData.genAddress,
          genSalutation: this.currentSelectedRowData.genSalutation,
          addressLine: this.currentSelectedRowData.addressLine,
          description: this.currentSelectedRowData.description,
          addition: this.currentSelectedRowData.addition,
          idMarker: this.currentSelectedRowData.idMarker,
          mdt: this.currentSelectedRowData.mdt,
          department: this.currentSelectedRowData.department,
          supervisor: this.currentSelectedRowData.supervisor,
          office: this.currentSelectedRowData.office,
          assistant: this.currentSelectedRowData.assistant,
          job: this.currentSelectedRowData.job,
          nickname: this.currentSelectedRowData.nickname,
          partner: this.currentSelectedRowData.partner,
          dateOfBirth: moment(this.currentSelectedRowData.dateOfBirth, 'YYYY-MM-DD').format('DD.MM.YYYY').toString(),
          anniversary: this.currentSelectedRowData.anniversary,
          children: this.currentSelectedRowData.children,
          active: this.currentSelectedRowData.active,
          financeRelevance: this.currentSelectedRowData.financeRelevance,
          position: this.currentSelectedRowData.position,
          businessPhone: this.currentSelectedRowData.businessPhone,
          privatePhone: this.currentSelectedRowData.privatePhone,
          businessMobile: this.currentSelectedRowData.businessMobile,
          privateMobile: this.currentSelectedRowData.privateMobile,
          businessMail: this.currentSelectedRowData.businessMail,
          privateMail: this.currentSelectedRowData.privateMail
        }

        this.onAddressEmployeeDialogSave(payload)
      }
    },

    onShowUnactiveEmployee (): void {
      this.currentSelectedRowId = ''
      this.currentSelectedRowData = undefined
      this.showAll = !this.showAll

      if(this.showAll) {
        this.gridData = _.cloneDeep(this.addressEmployee)
      } else {
        this.gridData = this.addressEmployee.filter((item: AddressEmployee) => item.active)
      }
    },

    onAddressEmployeeDialogClose (): void {
      this.showAddressEmployeeDialog = false
    },

    async onAddressEmployeeDialogSave (payload: AddressEmployeeDataPayload): Promise<void> {
      let action = "Insert"
      if(this.action === ActionsEnum.EDIT) {
        action = "Update"
      } else if(this.action === ActionsEnum.DELETE) {
        action = "Delete"
      }

      try {
        this.employeeDialogLoading = true
        await this.$store.dispatch(CREATE_ADDRESS_EMPLOYEE, {action: action, data: payload})
        this.employeeDialogLoading = false
        if(this.action === ActionsEnum.CREATE || this.action === ActionsEnum.EDIT) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else if (this.action === ActionsEnum.DELETE) {
          this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        }
        this.currentSelectedRowData = undefined
        await this.fetchAddressDetailData()
      } catch(e) {
        this.employeeDialogLoading = false
        if(this.action === ActionsEnum.CREATE || this.action === ActionsEnum.EDIT ) {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } else if (this.action === ActionsEnum.DELETE) {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
      this.showAddressEmployeeDialog = false
    },

    async fetchAddressDetailData (): Promise<void> {
      try {
        this.loading = true
        const response: AddressDetail = await this.$store.dispatch(FETCH_ADDRESS_DETAIL, this.selectedAddressId)
        if (response) {
          this.setData(response)
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    },

    setData (data: AddressDetail): void {
      this.selectedLanguage = data.language
      this.addressNumber = data.addressNumber
      this.sorting = data.sorting
      this.name = data.name
      this.land = data.land
      this.selectedAddressGroupId = data.addressGroup
      this.selectedSalutation = data.selectedSalutation
      this.selectedTitle = data.selectedTitle
      this.firstName = data.firstName
      this.addition = data.addition
      this.street = data.street
      this.pobox = data.pobox
      this.houseNumber = data.houseNumber
      this.postcode = data.postcode
      this.city = data.city
      this.region = data.region
      this.businessPhone = data.businessPhone
      this.privatePhone = data.privatePhone
      this.businessMobile = data.businessMobile
      this.businessMail = data.businessMail
      this.privateMail = data.privateMail
      this.webPage = data.webPage
      this.privateMobile = data.privateMobile
      this.description = data.description
      this.active = data.active
      this.isPrivateAddress = data.isPrivateAddress
      this.color = data.color
      //this.defaultColor = data.color
      this.geoLat = data.geoLat === undefined ? data.geoLat : data.geoLat.toString()
      this.geoLon = data.geoLon === undefined ? data.geoLon : data.geoLon.toString()

      this.addressEmployee = data.addressEmployee ? data.addressEmployee : []
      if(this.showAll && this.addressEmployee) {
        this.gridData = _.cloneDeep(this.addressEmployee)
      } else {
        this.gridData = this.addressEmployee.filter((item: AddressEmployee) => item.active)
      }
    },

    onCancelClick (): void {
      if(this.isEdit && this.addressAction === ActionsEnum.EDIT) {
        this.isEdit = false
        this.fetchAddressDetailData()
      } else if(this.isEdit && this.addressAction === ActionsEnum.CREATE) {
        this.onCloseDialog()
      }
    },

    async onSaveButtonClick (): Promise<void> {
      const form: any = this.$refs['form']
      if (form.validate()) {

        /*const privatePhonePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '006')
        const businessPhonePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '001')
        const privateMobilePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '007')
        const businessMobilePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '003')
        const privateMailPayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '008')
        const businessMailPayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '004')
        const webPagePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '005')*/

        const payload: AddressDataPayload = {
          id: this.selectedAddressId ? this.selectedAddressId : undefined,
          language: this.selectedLanguage,
          addressNumber: this.addressNumber,
          sorting: this.sorting,
          name: this.name,
          land: this.land,
          addressGroup: this.selectedAddressGroupId!,
          selectedSalutation: this.selectedSalutation,
          selectedTitle: this.selectedTitle,
          firstName: this.firstName,
          addition: this.addition,
          street: this.street,
          houseNumber: this.houseNumber,
          pobox: this.pobox,
          postcode: this.postcode,
          city: this.city,
          region: this.region,
          businessPhone: this.businessPhone,
          privatePhone: this.privatePhone,
          businessMobile: this.businessMobile,
          privateMail: this.privateMail,
          businessMail: this.businessMail,
          webPage: this.webPage,
          privateMobile: this.privateMobile,

          /*businessPhone: businessPhonePayload && businessPhonePayload.Nummer ? businessPhonePayload.Nummer : '',
          privatePhone: privatePhonePayload && privatePhonePayload.Nummer ? privatePhonePayload.Nummer : '',
          businessMobile: businessMobilePayload && businessMobilePayload.Nummer ? businessMobilePayload.Nummer : '',
          privateMail: privateMailPayload && privateMailPayload.Nummer ? privateMailPayload.Nummer : '',
          businessMail: businessMailPayload && businessMailPayload.Nummer ? businessMailPayload.Nummer : '',
          webPage: webPagePayload && webPagePayload.Nummer ? webPagePayload.Nummer : '',
          privateMobile: privateMobilePayload && privateMobilePayload.Nummer ? privateMobilePayload.Nummer : '',*/

          description: this.description,
          active: this.active,
          privateAddress: this.isPrivateAddress,
          color: this.color,
          geoLon: this.geoLon ? parseFloat(this.geoLon) : null,
          geoLat: this.geoLat ? parseFloat(this.geoLat) : null
        }

        let action = "Insert"
        if (this.addressAction !== ActionsEnum.DELETE) {
          if (this.selectedAddressId !== 0) {
            action = "Update"
            this.addressAction = ActionsEnum.EDIT
          } else {
            this.addressAction = ActionsEnum.CREATE
          }
        } else {
          action = "Delete"
        }

        try {
          this.saveLoading = true
          const response: any = await this.$store.dispatch(CREATE_ADDRESS, { action: action, data: payload })
          this.saveLoading = false
          if (this.addressAction === ActionsEnum.CREATE || this.addressAction === ActionsEnum.EDIT) {
            if(response) {
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
              this.showSnackbar = true

              if (this.addressAction === ActionsEnum.CREATE) {
                this.selectedAddressId = response
                this.$emit('addressCreated', response)
              }
              this.addressAction = ActionsEnum.EDIT
              this.fetchAddressDetailData()
              this.isEdit = false
              this.$emit('addressEdited')
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
              this.showSnackbar = true
            }
          } else if (this.addressAction === ActionsEnum.DELETE) {
            if(response) {
              this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
              this.snackbarState = SnackbarStateEnum.Success
              this.showSnackbar = true
              const deletedAddressId: number = this.selectedAddressId!
              const idx: number = this.addressIdList.indexOf(this.selectedAddressId!)
              if(this.addressIdList.length > 1) {
                if(this.addressIdList.length - 1 === idx) {
                  this.selectedAddressId = this.addressIdList[idx-1]
                  this.addressIdIndex = idx-1
                } else {
                  this.selectedAddressId = this.addressIdList[idx+1]
                }
              }
              this.$emit('addressDeleted', deletedAddressId)
              this.addressAction = ActionsEnum.CREATE
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
              this.snackbarState = SnackbarStateEnum.Error
              this.showSnackbar = true
            }
          }
        } catch (e) {
          this.saveLoading = false
          if (this.addressAction === ActionsEnum.CREATE || this.addressAction === ActionsEnum.EDIT) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          } else if (this.addressAction === ActionsEnum.DELETE) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        }
      }
    },

    async fetchPostCodeData (code: string): Promise<void> {
      if(code && this.land) {
        const payload: PostCodeDataPayload = {
          land: this.land,
          plz: code
        }
        const response: GetOrtPlzResponse = await this.$store.dispatch(FETCH_ADDRESS_POST_CODE_DATA, payload)
        if(!response.IsError && response.Data) {
          this.postCodeData = PostCodeData.createFromResponse(response.Data)
          if(this.postCodeData.length === 1) {
            this.city = this.postCodeData[0].ort
            this.region = this.postCodeData[0].region
          } else if(this.postCodeData.length > 1) {
            this.showPostCodeDialog = true
          }
        }
      }
    },

    async fetchAddressContactList (): Promise<void> {
      const response: GetContactListResponse = await this.$store.dispatch(FETCH_ADDRESS_CONTACT_LIST, this.selectedAddressId)
      if(!response.IsError && response.Data) {
        this.contactList = response.Data
      }
    },

    setDefaultValues (): void {
      this.selectedLanguage = 1
      this.selectedSalutation = 1
      this.land = 1
      this.isEdit = true
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    async searchCommission (): Promise<void> {
      const payload: KommissionSearchRequest = {
        ID: null,
        Nummer: '',
        Bezeichnung: '',
        GenAdresse: '',
        SachbearbeiterVollerName: '',
        Fach: '',
        Start: '',
        Termin: '',
        Bemerkungen: '',
        Status: 'alle',
        Art: '',
        KommissionZusatzfelderSearchItems: [],
        Mitarbeiter: this.currentUserId,
        Sprache: this.selectedLanguageId,
        MaxRecords: 500,
      }

      try {
        this.loading = true
        const response: KommissionSearchResponse = await this.$store.dispatch(FETCH_SEARCH_COMMISSION_LIST, payload)
        if(!response.IsError && response.Results) {
          this.commissionList = SearchCommission.createListFromResponse(response.Results)
          this.commissionList.forEach((item: SearchCommission) => {
            this.commissionIdList.push(item.id)
          })
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    async fetchCommissionArtList (): Promise<void> {
      try {
        this.commissionArtList = await this.$store.dispatch(FETCH_COMMISSION_GROUP)
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if (this.$route.path === '/address') {
        this.addressIdIndex = data && data.addressIdIndex ? data.addressIdIndex : 0
        if (this.addressIdList[this.addressIdIndex]) {
          this.selectedAddressId = this.addressIdList[this.addressIdIndex]
        } else {
          this.selectedAddressId = this.addressIdList[0]
        }
        this.activeTab = data.addressTab
        this.activeTab2 = data.addressTab2
      }
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Search(KeyActionEnum.search, this.searchClick, this.resolver, null)
    ]
  },

  async mounted (): Promise<void> {
    window.addEventListener('keydown', this.onKeydown)
    this.setDataFromRoute()

    //const color: string | null = localStorage.getItem('primaryColor')
    //this.defaultColor = color ? color : '#000'

    this.loading = true
    this.salutationList = await this.$store.dispatch(FETCH_SALUTATION)
    this.titleList = await this.$store.dispatch(FETCH_TITLE_LIST)
    this.landList = await this.$store.dispatch(FETCH_LAND_LIST)
    this.colorList = await this.$store.dispatch(FETCH_ADDRESS_COLOR_LIST)
    this.functionList = await this.$store.dispatch(FETCH_FUNCTION_LIST)

    if(this.selectedAddressId !== 0) {
      this.fetchAddressDetailData()
      this.fetchAddressContactList()
    } else {
      if(this.addressGroupId) {
        this.selectedAddressGroupId = this.addressGroupId
      }
      this.setDefaultValues()
    }
    this.loading = false
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
